import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { spacing } from "#app/theme/v2/spacing";
import { Divider } from "#components/atoms/Divider/Divider";
import { TextSkeleton } from "#components/atoms/Skeleton/Skeleton";
import { Text } from "#components/atoms/Typographies/Text";
import { Group } from "#shared/view/components/Group";
import { Stack } from "#shared/view/components/Stack";

type QuoteRequestCardSumProps = {
  isLoading?: boolean;
};
export const QuoteRequestCardSum = ({ isLoading = false }: QuoteRequestCardSumProps) => {
  const { t } = useTranslation();

  const sections = [
    { title: t("quoteRequestV2.cardSum.totalCost"), suffix: "€" },
    { title: t("quoteRequestV2.cardSum.transport"), suffix: "€" },
    { title: t("quoteRequestV2.cardSum.margin"), suffix: "%" },
    { title: t("quoteRequestV2.cardSum.totalPrice"), suffix: "€" },
  ];

  return (
    <Group
      gap={0}
      py={spacing[2]}
      bg={colors.bg.elevation.tertiary}
      style={{ borderRadius: radius.md, flexShrink: 0 }}
    >
      {sections.flatMap((section, i) => [
        <Stack key={section.title} gap={spacing[1]} px={spacing[4]} justify="center">
          <Text size="tiny" color={colors.text.secondaryDefault}>
            {section.title}
          </Text>
          {isLoading ? (
            <TextSkeleton size="small" />
          ) : (
            <Text size="small">{`-- ${section.suffix}`}</Text>
          )}
        </Stack>,
        i < sections.length - 1 ? (
          <Divider
            key={`sep-${i}`}
            orientation="vertical"
            style={{ height: 32, alignSelf: "center" }}
          />
        ) : null,
      ])}
    </Group>
  );
};
